import React from "react";
import { Form, Input, Checkbox } from "semantic-ui-react";
import "../../../styles/lms/lms-table.scss";
import { GlobalConstants } from "../../constants/GlobalConstants";

const LmsActionInput = (
  {
    handleChange,
    value,
    name = undefined as string | undefined,
    placeHolder = "",
    type = "text",
    inputClassName = "",
    label = "",
    isDisabled = false
  }
) => {
  return <div>
    <Form.Field>
      {type === GlobalConstants.FormInputTypes.CHECKBOX && <Checkbox
        className={inputClassName || "lms-table-action-checkbox"}
        label={label}
        checked={value}
        onChange={(_, { checked, name }) => handleChange(checked, name)}
        disabled={isDisabled}
        name={name}
      />}
      {type === "text" && <Input
        placeholder={placeHolder}
        onChange={(_, { value, name }) => handleChange(value, name)}
        type={type}
        name={name}
      >
        <input value={value} className={inputClassName || "lms-table-action-input"} />
      </Input>}
    </Form.Field>
  </div>;
};

export default LmsActionInput;